<template>
  <BaseControlBar :back-url="backUrl">
    <div class="flex-grow-1 section-header__title">
      <h1 v-if="role === 'admin'">
        新增最新消息
      </h1>
      <h1 v-else>
        {{title}}
      </h1>
    </div>
    <div class="admin-group" v-if="role === 'admin'">
      <template v-if="$route.name === 'AddNotification' && !readOnly">
          <BaseButton variant="success" @click="onSubmit">提交</BaseButton>
      </template>
      <template v-else>
        <template v-if="!readOnly">
          <BaseButton variant="outline-secondary" @click="onCancel">取消</BaseButton>
          <BaseButton variant="success" @click="onSubmit">提交</BaseButton>
        </template>
        <template v-else>
          <ButtonEdit @click="onEdit">編輯</ButtonEdit>
          <ButtonRemove
            @click="prepareAction('REMOVE', '你已移除這個紀錄')"
          >
            移除
          </ButtonRemove>
        </template>
      </template>
      <NotificationActionConfirmModal v-model="approval"
                                :onNotificationStatusUpdate="onNotificationStatusUpdate$"
                                :loading="loading"
      ></NotificationActionConfirmModal>
      <ActionSuccessModal v-model="actionSuccessModal"></ActionSuccessModal>
    </div>
  </BaseControlBar>
</template>

<script>
import { tap, switchMap } from 'rxjs/operators';
import controlBarMixin from '@/mixins/control-bar';
import BaseControlBar from '@/components/BaseControlBar.vue';
import NotificationActionConfirmModal from '@/components/notification/NotificationActionConfirmModal.vue';
import ActionSuccessModal from '@/components/ActionSuccessModal.vue';
import http from '../../helpers/http';
import ButtonRemove from '../button/ButtonRemove.vue';

export default {
  mixins: [controlBarMixin],
  components: {
    BaseControlBar,
    ButtonRemove,
    NotificationActionConfirmModal,
    ActionSuccessModal,
  },
  props: {
    validate: {
      type: Function,
    },
    role: String,
    deletedBy: String,
    readOnly: {
      type: Boolean,
    },
    title: String,
  },
  data: () => ({
    approval: {
      modal: false,
      action: null,
      remarks: null,
    },
    loading: false,
    stocksModal: false,
    isEdit: false,
    actionSuccessModal: {
      show: false,
      action: null,
      msg: null,
      back: {
        location: '/admin/notification',
        text: '返回最新消息',
      },
    },
  }),
  computed: {
    backUrl() {
      return this.role === 'admin' ? '/admin/notification' : '/notification';
    },
  },
  domStreams: ['onNotificationStatusUpdate$'],
  subscriptions() {
    return {
      notificationStatusUpdate: this.onNotificationStatusUpdate$.pipe(
        tap(() => {
          this.loading = true;
        }),
        switchMap(() => {
          const { action, msg } = this.approval;
          return http(
            {
              method: 'POST',
              url: '/agc-admin-api/notification/remove',
              data: {
                id: this.inputVal.id,
                deletedBy: this.deletedBy,
              },
            },
            {
              next: () => {
                if (msg) {
                  this.actionSuccessModal = {
                    ...this.actionSuccessModal,
                    show: true,
                    action,
                    msg,
                  };
                }
              },
              complete: () => {
                this.approval.modal = false;
                this.loading = false;
              },
            },
          );
        }),
      ),
    };
  },
  methods: {
    onSubmit() {
      if (this.$route.name === 'AddNotification') {
        this.$emit('submit-click');
      } else {
        this.$emit('resubmit-click');
      }
    },
    async prepareAction(action, msg) {
      this.approval = {
        modal: true,
        action,
        remarks: null,
        msg,
      };
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .approval-modal {
  &__header {
    border-bottom: none;
  }
}

.admin-group{
  display:flex;
}
</style>
